import { Routes } from './../../../../../server/routes/index';
import * as moment from 'moment';

export class ManualFetchingModal implements ng.IComponentOptions {
  public controller: any = ManualFetchingModalController;
  public bindings: any = {
    modalInstance: "<",
    resolve: "<"
  }
  public template: string = /*html*/`
  <div class="modal-header">
    <button type="button" class="close" ng-click="$ctrl.cancel()" aria-label="Close"><span aria-hidden="true">&times;</span></button>
    <h4 class="modal-title" id="datatypeModal">Manual SSH Fetching</h4>
  </div>
  <div class="modal-body">
    <div>Fetching on: {{$ctrl.dt | date:'fullDate'}}</div>
    <div class="row">
      <div class="col-md-12">
        <label class="radio-inline">
          <input type="radio" name="type" id="inlineRadio1" value="ssh" ng-model="$ctrl.type"> SSH
        </label>
        <label class="radio-inline">
          <input type="radio" name="tyoe" id="inlineRadio2" value="ftp" ng-model="$ctrl.type"> FTP
        </label>
      </div>
    </div>
    <div uib-datepicker ng-model="$ctrl.dt" class="well well-sm" datepicker-options="options"></div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" ng-click="$ctrl.submit()">Submit</button>
    <button type="button" class="btn btn-default" ng-click="$ctrl.cancel()">Close</button>
  </div>
  `
}

class ManualFetchingModalController {
  public static $inject: Array<string> = ["$http", "$timeout"];
  public modalInstance: ng.ui.bootstrap.IModalServiceInstance;
  public options: any
  public dt: Date
  public type: string
  constructor(private $http: ng.IHttpService, private $timeout: ng.ITimeoutService) {
    this.options = {
      minDate: moment().subtract(1, 'week').toDate(),
      maxDate: moment().add(1, 'week').toDate(),
      showWeeks: true
    };
  }
  public cancel() {
    this.modalInstance.dismiss('closed');
  }
  public submit() {
    this.modalInstance.close({date: this.dt, type:this.type});
  }
}